import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from './map.utils';

const initialState = {
  filter: {
    vehicleTypes: ['car', 'bicycle', 'cargo_bicycle', 'scooter'],
    providers: [],
    transmission: [],
    propulsion: [],
    returnOptions: null,
    commune: null,
    showEmptyStations: true,
  },
  filterHasInitialState: true,
  stations: null,
  vehicles: null,
}

const map = createSlice({
  name: 'map',
  initialState,
  reducers: {
    resetFilter: (state) => {
      state.filter = initialState.filter;
      state.filterHasInitialState = true;
    },
    setVehicleTypes: (state, action) => {
      state.filter.vehicleTypes = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
      if (JSON.stringify(action.payload) 
        !== JSON.stringify(initialState.filter.vehicleTypes) && window?.gtag) {
        window?.gtag('event', 'filter_changed', {
          event_category: 'Filter',
          event_label: 'vehicle types',
          filter_name: 'vehicle types',
          filter_value: action.payload?.join(', '),
        });
      }
    },
    setProviders: (state, action) => {
      state.filter.providers = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
      if (JSON.stringify(action.payload) 
        !== JSON.stringify(initialState.filter.providers) && window?.gtag) {
        window?.gtag('event', 'filter_changed', {
          event_category: 'Filter',
          event_label: 'providers',
          filter_name: 'providers',
          filter_value: action.payload?.map(i => i.label)?.join(', '),
        });
      }
    },
    setTransmission: (state, action) => {
      state.filter.transmission = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
      if (JSON.stringify(action.payload) 
        !== JSON.stringify(initialState.filter.transmission) && window?.gtag) {
        window?.gtag('event', 'filter_changed', {
          event_category: 'Filter',
          event_label: 'transmission',
          filter_name: 'transmission',
          filter_value: action.payload?.map(i => i.label)?.join(', '),
        });
      }
    },
    setPropulsion: (state, action) => {
      state.filter.propulsion = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
      if (JSON.stringify(action.payload) 
        !== JSON.stringify(initialState.filter.propulsion) && window?.gtag) {
        window?.gtag('event', 'filter_changed', {
          event_category: 'Filter',
          event_label: 'propulsion',
          filter_name: 'propulsion',
          filter_value: action.payload?.map(i => i.label)?.join(', '),
        });
      }
    },
    setReturnOptions: (state, action) => {
      state.filter.returnOptions = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
    },
    setCommune: (state, action) => {
      state.filter.commune = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
    },
    setShowEmptyStations: (state, action) => {
      state.filter.showEmptyStations = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
    },
    setStations: (state, action) => {
      state.stations = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
    },
    setVehicles: (state, action) => {
      state.vehicles = action.payload;
      state.filterHasInitialState = isEqual(state.filter, initialState.filter);
    },
  },
})

export const {
  resetFilter, setVehicleTypes, setProviders, setTransmission, setPropulsion, setReturnOptions, 
  setStations, setVehicles, setCommune, setShowEmptyStations,
} = map.actions;

export default map.reducer;
